import Vue from '../../node_modules/vue/dist/vue.esm';
import vSelect from 'vue-select';
import "../scss/style.scss";
import "./common";

const Home = () => import(/* webpackChunkName: "Home" */'./modules/home');
const Header = () => import(/* webpackChunkName: "Header" */'./modules/header');
const Footer = () => import(/* webpackChunkName: "Footer" */'./modules/footer');
const Signup = () => import(/* webpackChunkName: "Signup" */ './modules/signup');
const Signin = () => import(/* webpackChunkName: "Signin" */ './modules/signin');
const DocsManager = () => import(/* webpackChunkName: "DocsManager" */ './modules/docs-manager');
const Steps = () => import(/* webpackChunkName: "Steps" */ './modules/steps');
const Profile = () => import(/* webpackChunkName: "Profile" */ './modules/profile');
const StepsTrader = () => import(/* webpackChunkName: "StepsTrader " */ './modules/steps-trader');
const StepsDocs = () => import(/* webpackChunkName: "StepsDocs" */ './modules/steps-docs');
const StepsFast = () => import(/* webpackChunkName: "StepsFast" */ './modules/steps-fast');
const Quality = () => import(/* webpackChunkName: "Quality" */ './modules/quality');
const EulaAccept = () => import(/* webpackChunkName: "EulaAccept" */ './modules/eula-accept');
const Calculator = () => import(/* webpackChunkName: "Calculator" */ './modules/calculator');
const Search = () => import(/* webpackChunkName: "Search" */ './modules/search');
const LandingTrader = () => import(/* webpackChunkName: "LandingTrader" */ './modules/landing-trader');
const ReferalPayout = () => import(/* webpackChunkName: "ReferalPayout" */ './modules/referal-payout');
const LkNewPage = () => import(/* webpackChunkName: "LkNewPage" */ './modules/lknew');
const BistroVichet = () => import (/* webpackChunkName: "BistroVichet" */ './modules/bistrovichet');
const PolychiDengi = () => import (/* webpackChunkName: "PolychiDengi" */ './modules/polychidengi');
const StepsTurnkey = () => import(/* webpackChunkName: "StepsTurnkey" */ './modules/steps-turnkey');
const Contacts = () => import (/* webpackChunkName: "Contacts" */ './modules/contacts');
const Partners = () => import (/* webpackChunkName: "Partners" */ './modules/partners');
const Checklist = () => import (/* webpackChunkName: "Checklist" */ './modules/checklist');
const DocsUser = () => import (/* webpackChunkName: "DocsUser" */ './modules/docs');
const SravniPage = () => import (/* webpackChunkName: "SravniPage" */ './modules/sravni');
const StepsDocsPaid = () => import(/* webpackChunkName: "StepsDocsPaid" */ './modules/steps-docs-paid');
const Reviews = () => import(/*webpackChunkName: "Reviews" */ './modules/reviews');
const StepsSolution = () => import(/*webpackChunkName: "StepsSolution" */ './modules/steps-solution');
const StepsConsultation = () => import(/*webpackChunkName: "StepsConsultation" */ './modules/steps-consultation');
const YaidToken = () => import(/*webpackChunkName: "YaidToken" */ './modules/yaid-token');

Vue.component('v-select', vSelect);

Vue.filter('formatTime', function(value) {
    let sec_num = parseInt(value, 10);
    let hours   = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours   < 10) {hours   = "0" + hours;}
    if (minutes < 10) {minutes = "0" + minutes;}
    if (seconds < 10) {seconds = "0" + seconds;}

    if (hours > 0) {
        return hours + ':' + minutes + ':' + seconds;
    }
    return minutes + ':' + seconds;
});

Vue.filter('formatPhone', function (value) {
    if (value.length !== 10) {
        return value;
    }
    return '(' + value.substring(0, 3) + ') ' + value.substring(3, 6) + '-' + value.substring(6, 8) + '-' + value.substring(8, 10);
});

Vue.filter('objectLength', function (value) {
    if (typeof(value) !== 'object') {
        return 0;
    }
    return Object.keys(value).length;
});

Vue.filter('formatCurrency', function (value) {
    value = parseInt(value, 10);

    if (value) {
        return String(value.toFixed(0)).replace(/(\d)(?=(\d{3})+(\D|$))/g, '$1 ');
    }

    return '0';
});

Vue.filter('formatDate', function (value) {
    if (!(value instanceof Date)) {
        return '';
    }
    const months = [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря'
    ];
    return value.getDate() + ' ' + months[value.getMonth()] + ' ' + value.getFullYear();
});

function formatNumber(number) {
    return number < 10 ? '0' + String(number) : String(number);
}

Vue.filter('formatDateDefault', function (value) {
    if (!(value instanceof Date)) {
        return '';
    }
    return formatNumber(value.getDate()) + '.' + formatNumber((value.getMonth() + 1)) + '.' + value.getFullYear();
});

function createVueInstance (id, moduleImport) {
    const el = document.getElementById(id);
    if (el) moduleImport().then(module => new Vue({el: '#' + id, ...module.default}));
}

createVueInstance('home', Home);
createVueInstance('header', Header);
createVueInstance('footer', Footer);
createVueInstance('signin', Signin);
createVueInstance('signup', Signup);
createVueInstance('docs-manager', DocsManager);
createVueInstance('steps', Steps);
createVueInstance('profile', Profile);
createVueInstance('steps-trader', StepsTrader);
createVueInstance('steps-docs', StepsDocs);
createVueInstance('steps-fast', StepsFast);
createVueInstance('quality', Quality);
createVueInstance('eula-accept', EulaAccept);
createVueInstance('calculator-page', Calculator);
createVueInstance('search-page', Search);
createVueInstance('landing-trader', LandingTrader);
createVueInstance('payout', ReferalPayout);
createVueInstance('lk-page-new', LkNewPage);
createVueInstance('bistro-vichet', BistroVichet);
createVueInstance('polychi-dengi', PolychiDengi);
createVueInstance('steps-turnkey', StepsTurnkey);
createVueInstance('contacts', Contacts);
createVueInstance('partners', Partners);
createVueInstance('checklist', Checklist);
createVueInstance('docs-page', DocsUser);
createVueInstance('sravni-page', SravniPage);
createVueInstance('steps-docs-paid', StepsDocsPaid);
createVueInstance('reviews', Reviews);
createVueInstance('steps-solution', StepsSolution);
createVueInstance('steps-consultation', StepsConsultation);
createVueInstance('ya-token-page', YaidToken);
